import { createTheme } from '@mui/material/styles'
import { grey } from '@mui/material/colors'

import { AdminUITheme } from 'types/AdminUiThemeMui'

const DefaultPRMGridTheme = createTheme({
  ParticipantGrid: {
    globalBoxComponent: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      width: '100%',
    },
    displayFlexWithCenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
    addFilterButton: {
      paddingTop: '0.5rem',
    },
    selectedFilterWidth: {
      minWidth: '13.75rem',
    },
    clearFilterButton: {
      color: 'text.secondary',
      textTransform: 'uppercase',
      padding: '2px 5px',
    },
    participantGridMesurements: {
      height: 'calc(100vh - 300px)',
      width: '100%',
    },
    toolTipIconButton: {
      fontSize: '1rem',
      padding: 0,
    },
    paddingBottomZero: {
      paddingBottom: '0px',
    },
    paddingTopPointFive: {
      paddingTop: '0.5rem',
    },
    autocompleteInputProps: {
      paddingRight: '15px',
    },
    createGroupDialogCancelBtnMob: {
      display: { xs: 'flex', sm: 'none' },
    },
    deleteGroupDialogCancelBtnMob: {
      display: { xs: 'flex', sm: 'none' },
    },
    createGroupDialogCancelBtnDesk: {
      display: { xs: 'none', sm: 'inline-block' },
    },
    deleteGroupDialogCancelBtnDesk: {
      display: { xs: 'none', sm: 'inline-block' },
    },
    createGroupDialogActions: {
      paddingTop: { xs: 0, sm: 3 },
      paddingRight: 3,
      paddingBottom: 3,
      display: 'flex',
      justifyContent: { xs: 'space-between', sm: 'flex-end' },
      ml: { xs: '0.75rem' },
    },
    createGroupDialogContent: {
      paddingTop: 4,
      paddingBottom: { xs: 2.5, sm: 3 },
    },
    activityNotesBG: {
      backgroundColor: grey[50],
      boxShadow: 'none',
    },
    prmActivityNoteCard: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    fontSize16px: {
      fontSize: 16,
    },
    fontSize12px: {
      fontSize: 12,
    },
    ActivityNoteFilterHeight: {
      height: '45px',
    },
    importUsers: {
      box: {
        left: '2.5rem',
        right: '2.5rem',
        top: '2.875rem',
        bottom: '2.875rem',
        padding: '2rem',
      },
      header: {
        padding: '0rem',
        margin: '0rem',
      },
      actions: {
        padding: '0rem 2rem 2rem 0rem',
      },
      cancelButton: {
        marginRight: '0.75rem',
      },
      paperCss: {
        padding: '2rem',
      },
      dialog: {
        left: '2.5rem',
        right: '2.5rem',
        top: '2.875rem',
        bottom: '2.875rem',
      },
      alert1MB: {
        marginTop: '1rem',
      },
      firstPara: {
        marginTop: '2rem',
      },
      downloadCSV: {
        marginTop: '3rem',
      },
    },
  },
  Participant: {
    makeProjectAdminContent: {
      paddingTop: 2,
      paddingBottom: { xs: 2.5, sm: 3 },
    },
    makeProjectAdminContentActions: {
      paddingTop: { xs: 0, sm: 1 },
      paddingRight: 3,
      paddingBottom: 3,
      display: 'flex',
      justifyContent: { xs: 'space-between', sm: 'flex-end' },
      ml: { xs: '0.75rem' },
    },
    makeProjectAdminDialogCancelBtnMob: {
      display: { xs: 'flex', sm: 'none' },
    },
    makeProjectAdminDialogCancelBtnDesk: {
      display: { xs: 'none', sm: 'inline-block' },
    },
    filter: {
      width: '24.375rem',
    },
    header: {
      width: '100%',
      marginTop: '0rem',
    },
  },
} as AdminUITheme)

export default DefaultPRMGridTheme
